export const environment = {
  production: true,
  apiUrl: 'https://api.staging.pebra.ch/api/v1',
  appUrl: 'app.staging.pebra.ch',
  hubspot_id: '50'
};
